var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResizeAuto',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var resize = ref.resize;
return [_c('textarea',{staticClass:"textarea",attrs:{"rows":"1","placeholder":"입력해주세요"},domProps:{"value":_vm.value},on:{"input":resize,"keyup":function($event){return _vm.$emit('inputChanged', $event.target.value)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }